import classNames from "classnames";

const glossario: string[] = ['*', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

interface GlossarioProps {
    value: string;
    setValue: (item: string) => void;
}

export const Glossario: React.FC<GlossarioProps> = ({value, setValue}) => {
    const className = 'w-1/12 text-center text-blue-800 border border-blue-500 bg-blue-50 rounded-sm hover:font-bold';
    return (
        <div className="flex flex-row text-sm bg-white w-1/2 max-[1170px]:w-full max-[1170px]:text-xs max-sm:hidden">
            <nav className="select-none w-full inline-flex -space-x-px shadow-md m-3">
                {glossario.map((item) => {
                    return (<a key={item}
                               className={classNames(className, value === item ? 'bg-blue-500 text-white font-semibold' : undefined)}
                               onClick={() => setValue(item)}>
                                {item}
                            </a>)
                })}
            </nav>
        </div>
    )
}

export default Glossario;